import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Crypto from "crypto-js";
import { useSnackbar } from "notistack";
import { CommonApi } from "service/api/common.api";
import { ExtensionApi } from "service/api/extension.api";
import { QUERY_KEYS } from "service/constant/query-keys";
import { downloadFileByUrl } from "ultis/common";

export const useGetListExtensionV1 = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_LIST_V1, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListExtensionV1(params);
      return res.data;
    },
    ...options,
  });
};

export const useGetListExtension = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_LIST, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListExtension(params);
      return res.data;
    },
    ...options,
  });
};

export const useGetListExtensionContactCenter = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_CONTACT_CENTER_LIST, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListExtensionContactCenters(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useCreateExtension = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (payload) => {
      return ExtensionApi.createExtension(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EXTENSION_LIST] });
      enqueueSnackbar("Thêm máy lẻ thành công", { variant: "success" });
    },
  });
};

export const useEditExtension = (id) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => {
      return ExtensionApi.editExtension(id, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EXTENSION_LIST] });
    },
  });
};

export const useDeleteExtension = (id) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => {
      return ExtensionApi.deleteExtension(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EXTENSION_LIST] });
    },
  });
};

export const useGetExtensionDetail = (id, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_DETAIL, id],
    queryFn: async () => {
      const res = await ExtensionApi.getExtensionDetail(id);
      return res.data?.[0];
    },
    enabled: !!id,
    ...options,
  });
};

export const useExportListExtension = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_LIST_EXPORT, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListExtensionV1(params);
      const linkFile = res.data?.data?.linkFile;
      if (linkFile) {
        downloadFileByUrl(linkFile);
      }
    },
    ...options,
  });
};

export const useGetExtensionPassword = (id, secretKey, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_PASSWORD, id, secretKey],
    queryFn: async () => {
      // lấy địa chỉ ip người dùng, nếu ko lấy được gửi ip: ""
      let ipAddress = "";
      try {
        const ipAddressRes = await CommonApi.getClientIpAddressFromBeexVn();
        ipAddress = ipAddressRes.data;
      } catch (error) {
        console.log("error", error);
      }

      const res = await ExtensionApi.getExtensionPassword(id, ipAddress);
      if (res.data?.data?.password) {
        const passsword = Crypto.AES.decrypt(res.data.data.password, secretKey);
        return passsword.toString(Crypto.enc.Utf8);
      }
    },
    ...options,
  });
};

export const useGetExtensionSecretKey = (options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_SECRET_KEY],
    queryFn: async () => {
      // lấy key giải mã mật khẩu máy lẻ
      const secretKeyRes = await ExtensionApi.getExtensionSecretKey();
      return secretKeyRes.data?.data?.value;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListProvinceTypeExtension = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROVINCE_TYPE_EXTENSION_LIST, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListProvinceTypeExtension(params);
      return res.data?.data;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
};

export const useGetListExtensionContactCenterUnit = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.EXTENSION_CONTACT_CENTER_UNIT_LIST, params],
    queryFn: async () => {
      const res = await ExtensionApi.getListExtensionContactCentersUnit(params);
      return res.data?.data;
    },
    ...options,
  });
};
